import React from 'react';
import {BUS_PRESENCE_STATUS_CHANGE, PresenceStatus} from "../../../core/gd-presence/@const";

// links to growl notifications
let growlConnectionErrors : any[] = [];

type Props = {}

type State = {
    presenceStatus  : PresenceStatus
}

const debug = false
// const debug = "Connectivity"

export default class PresenceConnectivity extends React.Component<Props, State> {

    // public eventListner     : any

    constructor(props:Props) {
        super(props);

        this.state = {
            presenceStatus: gd.presence.status
        }
    }

    componentDidMount() {
        this.createEventListners();
    }

    componentWillUnmount() {
        this.destroyEventListners();
    }

    createEventListners = () => {
        // this.eventListner = this.onPresenceStatusChanged;
        // gd.presence.on("change:status",this.eventListner);
        gd.bus.subscribe(BUS_PRESENCE_STATUS_CHANGE, this, this.onPresenceStatusChanged)
    };

    destroyEventListners = () => {
        // gd.presence.off("change:status",this.eventListner);
        gd.bus.unsubscribe(this);
    };

    onPresenceStatusChanged = () => {

        const newStatus = gd.presence.status

        debug && console.log(debug, "onPresenceStatusChanged() newStatus=", newStatus)


        if (newStatus === PresenceStatus.DISCONNECTED) {
            growlConnectionErrors.push(gd.growl.connectionError(
                <span>You have been disconnected from the server. <span className="link-button" onClick={this.onClick}>Reconnect.</span></span>
            ));
        }

        if (newStatus === PresenceStatus.CONNECTED && growlConnectionErrors.length > 0) {
            growlConnectionErrors.forEach(gce => gd.growl.removeNotification(gce));
            growlConnectionErrors = [];
        }

        this.setState({
            presenceStatus: newStatus
        })
    }

    onClick = () => {
        gd.presence.reconnectManual();
    }

    render() {

        const classes = Classes("ui-connectivity", {
            'reconnect': this.state.presenceStatus === PresenceStatus.CONNECTING,
            'disconnected': this.state.presenceStatus === PresenceStatus.DISCONNECTED,
        });

        return (
            <div className={classes} onClick={this.onClick}>
                <div className="i5-plug"></div>
            </div>
        );
    }
}
